import { claimsSettlement } from '@/api/index'

export function Add_sh (data) {
  return claimsSettlement.request({
    method: 'post',
    url: '/Add_sh',
    data
  })
}

export function AddClaimsSettlement (data) {
  return claimsSettlement.request({
    method: 'post',
    url: '/AddClaimsSettlement',
    data
  })
}
export function CancelClaimsSettlement (data) {
  return claimsSettlement.request({
    method: 'post',
    url: '/CancelClaimsSettlement',
    data
  })
}
